// extracted by mini-css-extract-plugin
export default {"container":"admin_console_container__uSe1w","quotation_container":"admin_console_quotation_container__RSUVJ","areas_container":"admin_console_areas_container__ye0zh"};